export default {"src":"/_next/static/media/gamblefkkers.1188aad4.svg","height":375,"width":375,"blurWidth":0,"blurHeight":0};